import SiteLayout from "@/components/feature/SiteLayout";
import PageBanner from "@/components/feature/PageBanner";
import AboutSubNav from "@/components/feature/AboutSubNav";
import { location, siteInfo } from "@/mocks/about";

export default function AboutLocationPage() {
  return (
    <SiteLayout navVariant="solid">
      <PageBanner
        title="찾아오는 길"
        subtitle="경기도 시흥시에 위치한 본사 및 공장"
        breadcrumb={[
          { label: "회사소개", to: "/about/overview" },
          { label: "찾아오는 길" },
        ]}
        bgImage="https://readdy.ai/api/search-image?query=Modern%20clean%20industrial%20manufacturing%20facility%20interior%20with%20organized%20production%20floor%20and%20natural%20light%20streaming%20through%20windows%2C%20professional%20engineering%20environment%2C%20warm%20industrial%20aesthetic%2C%20soft%20ambient%20lighting%2C%20crisp%20architectural%20photography&width=1600&height=680&seq=krubber-about-banner&orientation=landscape"
      />
      <AboutSubNav />

      <section className="py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-12">
            <div className="lg:w-[480px] flex-shrink-0">
              <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950">
                연락처 및 주소
              </h2>
              <div className="mt-8 p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <ul className="flex flex-col gap-6">
                  <li className="flex items-start gap-4">
                    <span className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-2-line text-primary-600" />
                    </span>
                    <div>
                      <p className="text-xs font-bold text-foreground-500 uppercase tracking-wide">주소</p>
                      <p className="mt-1 text-sm font-semibold text-foreground-900 leading-relaxed">
                        {location.address}
                      </p>
                      <p className="text-xs text-foreground-500 mt-1">우) {location.postalCode}</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-4">
                    <span className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-primary-600" />
                    </span>
                    <div>
                      <p className="text-xs font-bold text-foreground-500 uppercase tracking-wide">전화</p>
                      <a href={`tel:${location.tel}`} className="mt-1 text-sm font-semibold text-foreground-900 hover:text-primary-600 transition-colors cursor-pointer">
                        {location.tel}
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4">
                    <span className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-printer-line text-primary-600" />
                    </span>
                    <div>
                      <p className="text-xs font-bold text-foreground-500 uppercase tracking-wide">팩스</p>
                      <p className="mt-1 text-sm font-semibold text-foreground-900">{location.fax}</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-4">
                    <span className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-600" />
                    </span>
                    <div>
                      <p className="text-xs font-bold text-foreground-500 uppercase tracking-wide">이메일</p>
                      <a href={`mailto:${location.email}`} className="mt-1 text-sm font-semibold text-foreground-900 hover:text-primary-600 transition-colors cursor-pointer">
                        {location.email}
                      </a>
                    </div>
                  </li>
                </ul>
              </div>

              <h2 className="text-xl font-heading font-extrabold text-foreground-950 mt-8">
                교통편 안내
              </h2>
              <div className="mt-4 p-6 rounded-xl bg-background-100 border border-background-200/70">
                <div className="flex items-start gap-3 mb-4">
                  <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-train-line text-accent-600 text-sm" />
                  </span>
                  <div>
                    <p className="text-xs font-bold text-foreground-500">지하철</p>
                    <p className="text-sm text-foreground-800 mt-0.5">{location.subway}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 mb-4">
                  <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-bus-line text-accent-600 text-sm" />
                  </span>
                  <div>
                    <p className="text-xs font-bold text-foreground-500">버스</p>
                    <p className="text-sm text-foreground-800 mt-0.5">{location.bus}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-car-line text-accent-600 text-sm" />
                  </span>
                  <div>
                    <p className="text-xs font-bold text-foreground-500">주차</p>
                    <p className="text-sm text-foreground-800 mt-0.5">{location.parking}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1 min-w-0">
              <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950">
                지도
              </h2>
              <div className="mt-8 rounded-2xl overflow-hidden border border-background-200/70 h-[600px]">
                <div
                  className="w-full h-full"
                  dangerouslySetInnerHTML={{ __html: location.mapEmbed }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}